<div class="chart-container">
    <p-chart type="line" [data]="data" [options]="chartOptions" [width]="'75vw'" [height]="'500px'"></p-chart>
</div>

<!-- <canvas id="lineChart"></canvas> -->
